import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';

// Check if running in native app
const isNative = Capacitor.isNativePlatform();

console.log('[Storage] Platform:', isNative ? 'Native' : 'Web');

// In-memory cache for the current session
let currentToken = null;
let currentUser = null;

/**
 * Simple storage service for DomusAI
 */
export const authStorage = {
  // Get token (sync for axios interceptor)
  getToken() {
    return currentToken;
  },

  // Get user
  getUser() {
    return currentUser;
  },

  // Save token after login
  async saveToken(token) {
    console.log('[Storage] Saving token...');
    currentToken = token;
    
    try {
      if (isNative) {
        await Preferences.set({ key: 'auth_token', value: token });
      } else {
        localStorage.setItem('auth_token', token);
      }
      console.log('[Storage] Token saved successfully');
    } catch (e) {
      console.error('[Storage] Error saving token:', e);
    }
  },

  // Save user after login
  async saveUser(user) {
    console.log('[Storage] Saving user...');
    currentUser = user;
    
    try {
      if (isNative) {
        await Preferences.set({ key: 'auth_user', value: JSON.stringify(user) });
      } else {
        localStorage.setItem('auth_user', JSON.stringify(user));
      }
      console.log('[Storage] User saved successfully');
    } catch (e) {
      console.error('[Storage] Error saving user:', e);
    }
  },

  // Load stored auth on app startup
  async loadAuth() {
    console.log('[Storage] Loading auth from storage...');
    
    try {
      if (isNative) {
        const tokenResult = await Preferences.get({ key: 'auth_token' });
        const userResult = await Preferences.get({ key: 'auth_user' });
        
        currentToken = tokenResult.value || null;
        currentUser = userResult.value ? JSON.parse(userResult.value) : null;
      } else {
        currentToken = localStorage.getItem('auth_token');
        const userStr = localStorage.getItem('auth_user');
        currentUser = userStr ? JSON.parse(userStr) : null;
      }
      
      console.log('[Storage] Auth loaded, hasToken:', !!currentToken);
      return { token: currentToken, user: currentUser };
    } catch (e) {
      console.error('[Storage] Error loading auth:', e);
      return { token: null, user: null };
    }
  },

  // Clear all auth data (logout)
  async clearAuth() {
    console.log('[Storage] Clearing auth...');
    currentToken = null;
    currentUser = null;
    
    try {
      if (isNative) {
        await Preferences.remove({ key: 'auth_token' });
        await Preferences.remove({ key: 'auth_user' });
      } else {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('auth_user');
      }
      console.log('[Storage] Auth cleared');
    } catch (e) {
      console.error('[Storage] Error clearing auth:', e);
    }
  },

  // Check if authenticated
  isAuthenticated() {
    return !!currentToken;
  }
};

export default authStorage;
